export interface IXMLData {
  banco?: string;
  cdacumulador?: string;
  cdcontacontabil?: string;
  cddominio?: string;
  cdservico?: string;
  cduser?: string;
  cfop?: string;
  cnpjempresa?: string;
  cnpjfornecedor?: string;
  csrf?: string;
  dtemissao?: string;
  dtentrada?: string;
  inss?: number;
  irrf?: number;
  isexportada?: string;
  isexterno?: string;
  iss?: number;
  nrnf?: string;
  vltotal?: number;
  chave?: string;
  nbs?: string;
}

export type XMLDatas = IXMLData[];

export const LABELXMLDATA = (key: string) => {
  let getter = {
    banco: 'Banco',
    cdacumulador: 'Cód. Acumulador',
    cdcontacontabil: 'Ct. Contábil',
    cddominio: 'Cód. Domínio',
    cdservico: 'Cód. Serviço',
    cduser: 'Cód. User',
    cfop: 'CFOP',
    cnpjempresa: 'CNPJ Tomador',
    cnpjfornecedor: 'CNPJ Prestador',
    csrf: 'CSRF',
    dtemissao: 'Dt. Emissão',
    dtentrada: 'Dt. Entrada',
    inss: 'INSS',
    irrf: 'IRRF',
    isexportada: 'Exportada?',
    isexterno: 'Externa?',
    iss: 'ISS',
    nrnf: 'Nr. Nota',
    serie: 'Série',
    vltotal: 'Valor Total',
    chave: 'Chave de Acesso',
    nbs: 'NBS',
  };
  return getter[key];
};
